import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import { RecoilRoot } from 'recoil'
import './assets/main.css'
import App from './components/main/App'
import reportWebVitals from './reportWebVitals'
import RecoilizeDebugger from 'recoilize'

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <RecoilRoot>
        <RecoilizeDebugger />
        <App />
      </RecoilRoot>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
